import React, { FC } from 'react';
import { TSummarySpecsProps } from '../../types/SeriesListing.types';

const SummarySpecs: FC<TSummarySpecsProps> = ({summarySpecs}) => {
  return (
      <ul className="product-card__summary-specs">
        {summarySpecs.map(({key,value}, index) => (
        <li className="product-card__summary-specs-item" key={`summary-spec-${index}`}>
          <p className="product-card__summary-specs-headline">
            {key}
          </p>
          <p className="product-card__summary-specs-value">
            {value}
          </p>
        </li>))}
       </ul>
  );
}

export default SummarySpecs;